var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"hero is-danger hidden-area"},[_vm._v("\n  Please login and complete your profile to see the details\n")])}
var staticRenderFns = []

export { render, staticRenderFns }